/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.portals.platform.app.rpc.FormMetadataRpc
 */

export const getFormMetadataRpc = {
  serviceName: 'com.hubspot.portals.platform.app.rpc.FormMetadataRpc',
  rpcName: 'getFormMetadata',
  auth: 'external',
  fingerprint: 'WQMcdHQk-EUM5-fkfQY-aEWCN6N5rP_v',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};